var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import ReactTooltip from 'react-tooltip';
import React from 'react';
export var createReactTooltip = function (tooltip, name, options) {
    var _a;
    // set default values
    options = __assign({ place: 'right' }, options);
    var tooltipDescription = typeof (tooltip === null || tooltip === void 0 ? void 0 : tooltip.description) === 'string'
        ? tooltip.description
        : ((_a = tooltip === null || tooltip === void 0 ? void 0 : tooltip.description) === null || _a === void 0 ? void 0 : _a.plainTextValue) || '';
    var tooltipContent = tooltip ? "<div>\n                                      <strong>" + tooltip.value + "</strong><br />\n                                      " + (tooltip.subtitle ? '<span>' + tooltip.subtitle + '</span><br />' : '') + "\n                                      <span>" + tooltipDescription + "</span>\n                                    </div>" : '';
    var tooltipId = [name, 'tooltip', Date.now()].filter(function (q) { return !!q; }).join('-');
    var tooltipElement = tooltip ? (React.createElement(ReactTooltip, { className: "accurity-tooltip", place: options.place, html: true, type: "dark", id: tooltipId })) : null;
    return {
        tooltipElement: tooltipElement,
        tooltipAnchorParams: tooltip ? {
            'data-tip': tooltipContent,
            'data-for': tooltipId
        } : {}
    };
};
//# sourceMappingURL=tooltip.js.map